import React, { useEffect, useState } from "react";
import { fetchAvailalbeAppointmentsForAutomaticResponseById } from "./DataServices/AppointmentsDataServices";
import {
  fetchAppointmentResponse,
  fetchAutomaticResponseHistoryById,
} from "./DataServices/AutomaticResponsesDataServices";
import { useParams } from "react-router-dom";
import { IAutomaticResponseHistory } from "./Models";
import Notification from "./Notification";
interface Slot {
  id: string;
  listingID: string;
  startTime: string;
  endTime: string;
  capacity: number;
  slotOrder: number;
  isDeleted: boolean;
}

export default function VacantConfirmation() {
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [notificationMessage, setNotificationMessage] = useState("");
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [slots, setSlots] = useState<Slot[]>([]);
  const { id } = useParams<{ id: string | undefined }>();
  const [selectedAppointment, setSelectedAppointment] = useState('');
  const [loading, setLoading] = useState(false);
  const [automaticResponseHistory, setAutomaticResponseHistory] = useState<IAutomaticResponseHistory>();
  const [phone, setPhone] = useState<string>();
  const okButtonFunction = async () => {
    try {
      if (id && selectedAppointment) {
        setLoading(true)
        await fetchAppointmentResponse(id, true, selectedAppointment, phone);
        setConfirmationMessage("Thanks for your confirmation");
        setLoading(false);
      }
    } catch (error) {
      setNotificationMessage(
        "Confirmation failed. Please try again or contact support."
      );
      setIsNotificationOpen(true);
      setLoading(false);
      setTimeout(() => {
        setIsNotificationOpen(false);
      }, 3000);
      console.error("Error fetching appointment response:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchAvailalbeAppointmentsForAutomaticResponseById(id)
        .then((fetchedSlots) => {
          setSlots(fetchedSlots);
        })
        .catch((error) => {
          console.error("Error fetching confirmed appointments:", error);
        });
    }
    // Assume fetchConfirmedAppointments() returns a Promise
  }, []); // Empty dependency array means this effect runs once when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const response = await fetchAutomaticResponseHistoryById(id);
          setAutomaticResponseHistory(response);
          if (response.confirmed) setConfirmationMessage("Appointment already confirmed!")
          if (response.rejected || response.cancelled) setConfirmationMessage("Sorry, Your Appointment is cancelled!")
        }
      } catch (error) {
        console.error("Error fetching:", error);
      }
    };

    fetchData();
  }, [id, confirmationMessage]);

  useEffect(() => {
    if (slots.length > 0)
      setSelectedAppointment(slots[0].id)
  }, [slots])

  const cancelButtonFunction = async () => {
    // Perform any logic needed on "No" button click
    try {
      if (id) {
        await fetchAppointmentResponse(id, false); //confirm the appointment
        setConfirmationMessage(
          "No worries! We'll keep you informed about upcoming schedules."
        );

        // Handle the case when the response is false
      }
    } catch (error) {
      setIsNotificationOpen(true);
      setNotificationMessage(
        "Rejection failed. Please try again or contact support."
      );
      setTimeout(() => {
        setIsNotificationOpen(false);
      }, 3000);
      console.error("Error fetching appointment response:", error);
    }
  };

  const isPhoneVaild = () => {
    if (phone && phone.trim().length > 6) return !/[a-zA-Z]/.test(phone.trim());
    return false;
  }

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="box-border shadow border-slate-200 rounded p-[5vh] m-2 border max-w-xl">
        {confirmationMessage && (
          <>
            <div className="w-full">

              {/* <CalendarDaysIcon fontSize="Large" /> */}
              <div className="flex items-center justify-center">
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 100 100"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="10" y="30" width="80" height="60" rx="12" fill="#F5F5F5" stroke="#CCCCCC" strokeWidth="2" />
                  <rect x="10" y="10" width="80" height="30" rx="8" fill="#D32F2F" />

                  <circle cx="20" cy="25" r="6" fill="white" stroke="#888" strokeWidth="2" />
                  <circle cx="80" cy="25" r="6" fill="white" stroke="#888" strokeWidth="2" />

                  <text x="50" y="30" fontSize="14" textAnchor="middle" fill="white" fontFamily="Arial" fontWeight="bold">{automaticResponseHistory ? new Date(automaticResponseHistory.startTime).toLocaleString('en-US', { month: 'short' }) : "Jan"}</text>

                  <text x="50" y="75" fontSize="35" textAnchor="middle" fill="black" fontFamily="Arial" fontWeight="bold">{automaticResponseHistory ? new Date(automaticResponseHistory.startTime).getDate() : 0}</text>
                </svg>

              </div>
              {automaticResponseHistory?.confirmed && <div className="text-base font-medium text-green-600 text-center my-2">{`Hey ${automaticResponseHistory?.firstName}, your appointment`}<br /> {"has been successfully confirmed"}</div>}
              {automaticResponseHistory?.cancelled && <div className="text-base font-medium text-red-600 text-center my-2">{`Hey ${automaticResponseHistory?.firstName}, your appointment`}<br /> {"was successfully canceled!"}</div>}
              <div className="text-2xl font-bold text-center my-4">{automaticResponseHistory?.title}</div>
              <div className="text-center text-indigo-600">{automaticResponseHistory && formatDateTime(automaticResponseHistory.startTime.toString()) + " "}
                to {automaticResponseHistory && formatDateTime(automaticResponseHistory.endTime.toString())}</div>
            </div>
            <p className="text-center my-2">
              If you need to reschedule or have any questions, please contact
              us. Looking forward to your visit!
            </p>
          </>
        )}
        {!confirmationMessage && (
          <div>
            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <p className="text-lg font-bold leading-6 text-gray-900 justify-center mb-10">
                Appointment Confirmation?
              </p>
              <div className="mt-2">
                <p className=" text-gray-600 text-justify">
                  Please confirm your availability for a scheduled visit to
                  the <strong>{automaticResponseHistory?.title}</strong> apartments. We want to ensure that the apartment aligns
                  with your requirements and preferences before finalizing the
                  process. Are you ready to proceed with the visit? If yes, please
                  also select the available time slots below.
                </p>

                <form className="my-3">
                  <label htmlFor="phone-input" className="block mb-2 text-sm font-medium text-gray-900">Phone number:</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
                      <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 19 18">
                        <path d="M18 13.446a3.02 3.02 0 0 0-.946-1.985l-1.4-1.4a3.054 3.054 0 0 0-4.218 0l-.7.7a.983.983 0 0 1-1.39 0l-2.1-2.1a.983.983 0 0 1 0-1.389l.7-.7a2.98 2.98 0 0 0 0-4.217l-1.4-1.4a2.824 2.824 0 0 0-4.218 0c-3.619 3.619-3 8.229 1.752 12.979C6.785 16.639 9.45 18 11.912 18a7.175 7.175 0 0 0 5.139-2.325A2.9 2.9 0 0 0 18 13.446Z" />
                      </svg>
                    </div>
                    <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2.5  " pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" placeholder="123-456-7890" required />
                  </div>
                </form>

              </div>
            </div>
            <div className="mt-12 sm:mt-4 justify-between sm:flex sm:flex-row ">
              <button
                type="button"
                disabled={!isPhoneVaild()}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto disabled:bg-indigo-300"
                onClick={okButtonFunction}
              >
                Yes, I will attend.
              </button>

              <button
                type="button"
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                onClick={cancelButtonFunction}
              >
                No, I don't want to attend.
              </button>
            </div>
            <div className="mt-10 relative block text-left">
              <label
                htmlFor="slots"
                className="inline-flex  justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 "
              >
                Select available slots:
              </label>
              <select
                id="slots"
                name="slots"
                className="text-sm mt-2 w-60 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"

                // Default to empty if not selected
                onChange={(e) =>
                  setSelectedAppointment(e.target.value)
                }
              >
                {slots.sort((a, b) => {
                  const timeA = new Date(a.startTime).getTime() || 0;  // Fallback to 0 if invalid
                  const timeB = new Date(b.startTime).getTime() || 0;
                  return timeA - timeB;
                }).map((slot, index) => (
                  <option value={slot.id} key={index} >
                    {formatDateTime(slot.startTime)}{" "}
                    -{" "}
                    {formatDateTime(slot.endTime)}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>
      <Notification
        isOpen={isNotificationOpen}
        setIsOpen={setIsNotificationOpen}
        message={notificationMessage}
        messageType="error"
      />
    </div>
  );
}

export function formatDateTime(dateString: string) {
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    month: 'long',  // "May"
    day: 'numeric',  // "7"
    year: 'numeric',  // "2022"
    hour: 'numeric',  // "6"
    minute: '2-digit',  // "00"
    hour12: true,  // "PM/AM"
  });
};